module.exports = __webpack_public_path__ + "static/media/mobile-menu-icon-black.b75f51a7.svg";